import React from "react";
import { Breadcrumb } from "../components/Breadcrumb";

export const HelpPage = () => (
  <>
    <Breadcrumb items={[{ text: "Help", link: "/help" }]} />
  </>
);
